import { render, staticRenderFns } from "./jk.vue?vue&type=template&id=0ef12938&scoped=true&"
import script from "./jk.vue?vue&type=script&lang=js&"
export * from "./jk.vue?vue&type=script&lang=js&"
import style0 from "./jk.vue?vue&type=style&index=0&id=0ef12938&lang=less&scoped=true&"
import style1 from "./jk.vue?vue&type=style&index=1&id=0ef12938&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef12938",
  null
  
)

export default component.exports